// {% comment %} Wellesley, MA == Liliko East Market {% endcomment %}
// {% comment %} Menlo Park, CA == Liliko West Market {% endcomment %}
const EAST_STORE = { lat: 42.2964, lng: 71.2926, url: "https://www.lilikomarket.com/?redirect=redirect_from_menlo_park_ca" };
const WEST_STORE = { lat: 37.45, lng: 122.1817, url: "https://ca.lilikomarket.com/?redirect=redirect_from_wellesley_ma" };

// Elements
const overlay = document.getElementById("storeLocationSwitcherOverlay");
const closeBtn = document.getElementById("storeLocationSwitcherCloseButton");
const trigger = document.getElementById("storeLocationSwitcherTrigger");
const selectBox = document.getElementById("storeLocationSwitcherSelect");
const options = document.querySelectorAll(".store-location-switcher-option");
const selectedLabel = document.getElementById("storeLocationSwitcherSelectedLabel");
const switchBtn = document.getElementById("storeLocationSwitcherSwitchButton");
const manualOpenBtn = document.getElementById("storeLocationSwitcherOpenButton");

let selectedStore = null;
// ----------------------------
// REDIRECT PARAM HANDLER (12h)
// ----------------------------
(function handleRedirectParam() {
  const params = new URLSearchParams(window.location.search);
  const redirectParam = params.get("redirect");

  if (redirectParam === "redirect_from_wellesley_ma") {
    localStorage.setItem("redirect_flag", "true");
    localStorage.setItem("redirect_time", Date.now());
  }
})();
// ----------------------------
// GET CURRENT STORE
// ----------------------------
function getCurrentStore() {
  const host = window.location.hostname;

  if (host === "lilikomarket.com" || host === "www.lilikomarket.com") {
    return "east";
  }

  if (host === "ca.lilikomarket.com") {
    return "west";
  }

  return "west"; // fallback
}

// ----------------------------
// DISTANCE UTILITY
// ----------------------------
function distance(lat1, lon1, lat2, lon2) {
  return Math.sqrt(Math.pow(lat1 - lat2, 2) + Math.pow(lon1 - lon2, 2));
}

function detectNearestStore(lat, lng) {
  if (lat != null && lng != null) {
    const eastDist = distance(lat, lng, EAST_STORE.lat, EAST_STORE.lng);
    const westDist = distance(lat, lng, WEST_STORE.lat, WEST_STORE.lng);
    return eastDist < westDist ? "east" : "west";
  }
  return "west";
}

// ----------------------------
// POPUP CONTROL
// ----------------------------
function showPopup() {
  // ❌ selectedStore = null;  REMOVE THIS

  overlay.classList.add("is-visible");
  document.body.classList.add("store-location-switcher-lock-scroll");

  // ✅ Restore last selection from localStorage if exists
  const savedStore = localStorage.getItem("preferred_store");

  if (savedStore) {
    selectedStore = savedStore;

    selectedLabel.innerText =
      savedStore === "east" ? "Wellesley, MA" : "Menlo Park, CA";

    options.forEach(o => {
      o.classList.remove("is-active");
      if (o.dataset.store === savedStore) {
        o.classList.add("is-active");
      }
    });
  }
}

function closePopup() {
  overlay.classList.remove("is-visible");
  document.body.classList.remove("store-location-switcher-lock-scroll");
}

// ----------------------------
// SAVE STORE
// ----------------------------
function saveStoreChoice(store) {
  localStorage.setItem("preferred_store", store);
  localStorage.setItem("store_time", Date.now());
}

// ----------------------------
// REDIRECT
// ----------------------------
function redirectStore(store) {
  const currentStore = getCurrentStore();

  if (store === "east" && currentStore !== "east") {
    window.location.href = EAST_STORE.url;
    return;
  }

  if (store === "west" && currentStore !== "west") {
    window.location.href = WEST_STORE.url;
    return;
  }

  // already on correct store
  closePopup();
}

// ----------------------------
// DROPDOWN
// ----------------------------
if (trigger && selectBox) {
  trigger.addEventListener("click", () => selectBox.classList.toggle("is-open"));
}

document.addEventListener("click", (e) => {
  if (selectBox && !selectBox.contains(e.target)) selectBox.classList.remove("is-open");
});

options.forEach(option => {
  option.addEventListener("click", () => {
    options.forEach(o => o.classList.remove("is-active"));
    option.classList.add("is-active");

    const name = option.dataset.storeName;
    selectedLabel.innerText = name;

    selectedStore = option.dataset.store;

    // ✅ persist instantly
    localStorage.setItem("last_selected_store", selectedStore);

    selectBox.classList.remove("is-open");
  });
});
const lastSelected = localStorage.getItem("last_selected_store");
if (lastSelected) {
  selectedStore = lastSelected;
}


if (switchBtn) {
  switchBtn.addEventListener("click", () => {
    if (!selectedStore) return;
    saveStoreChoice(selectedStore);
    redirectStore(selectedStore);
  });
}

if (closeBtn) {
  closeBtn.addEventListener("click", () => {
    const currentStore = getCurrentStore();

    // ✅ Same behavior as "Stay Here"
    saveStoreChoice(currentStore);

    // ✅ Also persist last selected dropdown (important fix)
    if (selectedStore) {
      localStorage.setItem("last_selected_store", selectedStore);
    }

    closePopup();
  });
}
if (manualOpenBtn) manualOpenBtn.addEventListener("click", showPopup);

// ----------------------------
// DETECT STORE
// ----------------------------
function detectStore() {
  const savedStore = localStorage.getItem("preferred_store");
  const savedTime = localStorage.getItem("store_time");

  const redirectFlag = localStorage.getItem("redirect_flag");
  const redirectTime = localStorage.getItem("redirect_time");

  const now = Date.now();
  const twelveHours = 12 * 60 * 60 * 1000;

  const currentStore = getCurrentStore();

  // ----------------------------
  // 🚫 BLOCK POPUP IF REDIRECT PARAM USED
  // ----------------------------
  if (redirectFlag && redirectTime && (now - redirectTime) <= twelveHours) {
    console.log("🚫 Redirect flag active → No popup");
    return;
  }

  // ❌ expire redirect flag after 12h
  if (redirectTime && (now - redirectTime) > twelveHours) {
    localStorage.removeItem("redirect_flag");
    localStorage.removeItem("redirect_time");
  }

  // ----------------------------
  // NORMAL FLOW
  // ----------------------------

  if (!savedStore || !savedTime || (now - savedTime) > twelveHours) {
    checkGeoAndShowPopup();
    return;
  }

  if (savedStore !== currentStore) {
    showPopup();
    return;
  }

  console.log("User already on correct store. No popup.");
}

// ----------------------------
// GEO CHECK + AUTO SAVE
// ----------------------------
function checkGeoAndShowPopup() {
  if (!navigator.geolocation) {
    showPopup();
    return;
  }

  navigator.geolocation.getCurrentPosition(pos => {
    const nearest = detectNearestStore(pos.coords.latitude, pos.coords.longitude);
    const currentStore = getCurrentStore();

    console.log("Geo detected nearest:", nearest, "current store:", currentStore);

    if (nearest === currentStore) {
      // ✅ User near correct store → auto save & no popup
      saveStoreChoice(currentStore);
      console.log("✅ Auto saved localStorage. No popup shown.");
      return;
    }

    // ❌ User not near store → show popup
    showPopup();
    selectedStore = nearest;
    selectedLabel.innerText = nearest === "east" ? "Wellesley, MA" : "Menlo Park, CA";
  }, () => {
    // Geo denied → show popup
    showPopup();
  });
}

// ----------------------------
window.addEventListener("load", detectStore);